import {
	Button,
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from "@dune/ui";
import { AlertTriangle } from "lucide-react";
import React from "react";

interface ModifyInformationModalProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onConfirm: () => void;
	onCancel: () => void;
}

const ModifyInformationModal: React.FC<ModifyInformationModalProps> = ({
	open,
	onOpenChange,
	onConfirm,
	onCancel,
}) => {
	const handleConfirm = () => {
		onConfirm();
		onOpenChange(false);
	};

	const handleCancel = () => {
		onCancel();
		onOpenChange(false);
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<div className="flex items-center gap-3">
						<AlertTriangle className="h-5 w-5 text-orange-500" />
						<DialogTitle>Modification des informations</DialogTitle>
					</div>
				</DialogHeader>

				<div className="space-y-3 text-sm text-gray-700">
					<p>
						La modification de ces informations nécessite la réédition d'une
						indication tarifaire.
					</p>
					<p>
						<strong>Les informations et documents restent sauvegardés.</strong>
					</p>
					<p>
						Pour reprendre la soumission de votre dossier, vous devrez,
						néanmoins, choisir cette nouvelle indication tarifaire.
					</p>
				</div>

				<div className="grid grid-cols-2 gap-3">
					<Button variant="outline" className="w-full" onClick={handleCancel}>
						Annuler
					</Button>
					<Button variant="default" className="w-full" onClick={handleConfirm}>
						Continuer
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default ModifyInformationModal;
